const hasRole = (authorities, role) =>
  authorities.some((item) => item.authority === role);

const canAccess = (authorities, roles) =>
  roles.some((role) => hasRole(authorities, role));


export const buildNavigationSections = (authorities = []) => {
  const isOwner = hasRole(authorities, "OWNER");
  const isLogist = hasRole(authorities, "LOGIST");
  const isAccountant = hasRole(authorities, "ACCOUNTANT");

  const sections = [
    ...(!isAccountant
      ? [
          {
            label: "Aдминка",
            icon: "pi pi-fw pi-briefcase",
            description: "Операционное управление логистикой",
            items: [
              {
                label: "Заказы",
                path: "/orders",
                icon: "pi pi-shopping-bag",
                description: "Создание и сопровождение отправлений",
              },
              {
                label: "Поставщики",
                path: "/postal_services",
                icon: "pi pi-truck",
                description: "Управление перевозчиками и сервисами",
              },
              {
                label: "Поставщики SLQ",
                path: "/slq_postal_services",
                icon: "pi pi-send",
                description: "Настройка сервисов для портала SLQ",
              },
              {
                label: "Категория товаров",
                path: "/product_categories",
                icon: "pi pi-tags",
                description: "Классификация товаров для расчетов",
              },
              {
                label: "Направления",
                path: "/postal_routes",
                icon: "pi pi-map",
                description: "Маршруты и логистические плечи",
              },
              {
                label: "Калькулятор",
                path: "/calculator",
                icon: "pi pi-calculator",
                description: "Оценка тарифов и сроков доставки",
              },
              {
                label: "Калькулятор (разделённый по плечам)",
                path: "/calculator_shoulders",
                icon: "pi pi-share-alt",
                description: "Детализированный расчет по этапам",
              },
              {
                label: "Мониторинг статусов",
                path: "/status_monitoring",
                icon: "pi pi-chart-line",
                description: "Отслеживание этапов доставки",
              },
              {
                label: "Справочники",
                path: "/catalog",
                icon: "pi pi-book",
                description: "Базовые параметры и справочные данные",
              },
            ],
          },
        ]
      : []),
    {
      label: "SLQ Портал",
      icon: "pi pi-fw pi-link",
      description: "Пользователи и точки обслуживания",
      items: isAccountant
        ? [
            {
              label: "Пользователи",
              path: "/users",
              icon: "pi pi-users",
              description: "Управление пользователями портала",
            },
          ]
        : [
            {
              label: "Пользователи",
              path: "/users",
              icon: "pi pi-users",
              description: "Управление пользователями портала",
            },
            {
              label: "Терминалы ГП/Кросс-докинг",
              path: "/terminals",
              icon: "pi pi-building",
              description: "Сеть терминалов и локаций",
            },
          ],
    },
    ...(!isAccountant
      ? [
          {
            label: "Тарифы",
            icon: "pi pi-fw pi-chart-bar",
            description: "Настройка финансовых правил",
            items: [
              {
                label: "Администрирование тарифов",
                path: "/calc-tariffs",
                icon: "pi pi-sliders-h",
                description: "Управление тарифными сетками",
              },
              {
                  label: "Администрирование тарифов кросс-докинга",
                  path: "/cross-docking-tarrifs",
                  icon: "pi pi-sliders-h",
                  description: "Управление тарифными сетками кросс-докинга",
              },
              {
                label: "Администрирование маржинальности",
                path: "/slq-tariffs",
                icon: "pi pi-sliders-h",
                description: "Управление тарифными сетками маржинальности",
              },
            ],
          },
        ]
      : []),
    ...(isOwner && !isAccountant
      ? [
          {
            label: "Интеграции/Администрирование",
            icon: "pi pi-fw pi-cog",
            description: "Системные панели и контроль",
            items: [
              {
                label: "Панель",
                path: "/panel",
                icon: "pi pi-th-large",
                description: "Системный обзор и очереди",
              },
              {
                label: "DPD",
                path: "/panel/dpd",
                icon: "pi pi-bolt",
                description: "Управление интеграцией DPD",
              },
              {
                label: "Пользователи",
                path: "/panel/users",
                icon: "pi pi-id-card",
                description: "Администрирование учетных записей",
              },
              {
                label: "Аудит лог",
                path: "/panel/audit-logs",
                icon: "pi pi-file-edit",
                description: "Проверка системных событий",
              },
            ],
          },
        ]
      : []),
    ...(isOwner || isLogist
      ? [
          {
            label: "Биллинг",
            icon: "pi pi-fw pi-credit-card",
            description: "Учет и финансовые справочники",
            items: [
              {
                label: "Справочники по учету",
                path: "/billing/accounting-catalog",
                icon: "pi pi-wallet",
                description: "Справочники для биллинга",
              },
              {
                label: "Расчет оплаты услуг по ГПХ",
                path: "/billing/clc-payment-calculator",
                icon: "pi pi-calculator",
                description: "Расчет оплаты услуг по договорам ГПХ",
              },
              {
                label: "Журнал обязательств",
                path: "/billing/obligations-journal",
                icon: "pi pi-bookmark",
                description: "Просмотр и контроль журнала обязательств",
              },
            ],
          },
        ]
      : []),
  ];

  return sections;
};

export const toMenubarModel = (sections, onNavigate) =>
  sections.map((section) => ({
    label: section.label,
    icon: section.icon,
    items: section.items.map((item) => ({
      label: item.label,
      icon: item.icon,
      command: () => onNavigate(item.path),
    })),
  }));

export const getAccessibleModules = (authorities = []) => {
  const sections = buildNavigationSections(authorities);
  return sections.flatMap((section) =>
    section.items.map((item) => ({
      ...item,
      sectionLabel: section.label,
      sectionIcon: section.icon,
    }))
  );
};

export const hasRootAccess = (authorities = []) =>
  canAccess(authorities, ["ADMIN", "OWNER", "LOGIST", "SUPERUSER", "ACCOUNTANT"]);
